
export const common = {
  // Navigation
  'nav.language': 'English',
  'nav.flanexus': 'Flanexus',
  'nav.news': 'News',
  'nav.contact': 'Contact Us',
  
  // Hero Section
  'hero.title': 'Asia Digital\nInstitute',
  'hero.description': 'ADI is committed to building a professional digital market service platform in the Asia-Pacific region, providing enterprises with comprehensive digital services from planning to implementation. Based on in-depth consulting services, combined with rich practical experience, industry expert insights, and advanced methodological tools, we provide enterprises with customized solutions and implementation services. ADI is committed to improving the success rate of enterprise projects, optimizing return on investment, and effectively managing risks.',
  'hero.cta': 'Contact Us',
  
  // Accelerate Thinking Section
  'thinking.title': 'Accelerate Thinking',
  'thinking.subtitle': 'Help CXO evaluate fundamental strategic issues such as omnichannel and digital solutions',
  'thinking.activity.title': 'Activities',
  'thinking.activity.desc': 'Salons and forums serve as exclusive think tanks for CIO/CDO, aimed at promoting strategic dialogue on digital transformation trends and challenges in Southeast Asia to foster innovation and sustainable growth.',
  'thinking.insight.title': 'Insights',
  'thinking.insight.desc': 'Research the digitalization process in the Asia-Pacific region, including technological advances, policy changes, market trends, consumer behavior, and the impact of digitalization on the economy and society.',
  'thinking.execution.title': 'Execution',
  'thinking.execution.desc': 'Through digital consulting and implementation, help organizations assess their current digital level, plan future digital strategies, and execute these strategies to achieve business goals.',
  
  // Cooperation Section
  'cooperation.title': 'Cooperation and Support',
  'cooperation.subtitle': 'Through ADI consultant network, enterprises will gain international perspective and best business practices',
  'cooperation.insight.title': 'Industry Insights',
  'cooperation.insight.desc': 'Through in-depth research and analysis of industry trends, market dynamics and technological advances, ADI helps clients gain deep understanding of the industry',
  'cooperation.research.title': 'Market Research',
  'cooperation.research.desc': 'Through continuous research and analysis, ADI has accumulated rich market knowledge and can provide professional market insights and strategies for clients',
  'cooperation.alliance.title': 'Strategic Alliance',
  'cooperation.alliance.desc': 'ADI establishes partnerships with industry leaders and decision-makers to help clients expand their influence and access key resources',
  'cooperation.dialogue.title': 'Dialogue Discussion',
  'cooperation.dialogue.desc': 'ADI communicates closely with clients to understand their business goals and challenges, thereby providing customized solutions',
  'cooperation.mutual.title': 'Continuous Mutual Benefit',
  'cooperation.mutual.desc': 'ADI is committed to establishing long-term partnerships with clients, ensuring both parties benefit from cooperation by providing long-term value',
  'cooperation.tech.title': 'Technical Cooperation',
  'cooperation.tech.desc': 'Supported by Flanexus technology, the institute enhances its services by leveraging Flanexus technical capabilities through cooperation',
  'cooperation.implementation.title': 'Implementation Resources',
  'cooperation.implementation.desc': 'ADI not only provides strategic consulting but also integrates implementation resources to ensure consulting recommendations are effectively executed',
  'cooperation.influence.title': 'Influence',
  'cooperation.influence.desc': 'ADI can provide high-quality services and play an important role in clients strategic decision-making',
  
  // Mission Section
  'mission.title': 'Mission and Vision',
  'mission.subtitle': 'Shape the digital future of Asia-Pacific, inject new momentum for global development',
  'mission.mission': 'Mission',
  'mission.mission.desc': 'As a digital transformation leader in Asia, especially Southeast Asia, ADI is committed to promoting sustainable and inclusive digital innovation.',
  'mission.vision': 'Vision',
  'mission.vision.desc': 'Build an ecosystem of top chief information officers and digital leaders, providing strategic guidance to enterprises through ADI industry-leading consulting and cutting-edge technology solutions.',
  
  // Framework Section
  'framework.title': 'ADI Digital Transformation Framework',
  'framework.strategy.title': 'Strategy & Compliance',
  'framework.strategy.desc': 'Help enterprises achieve strategic goals while ensuring compliance with local regulations, strengthening data security and governance, laying the foundation for sustainable development.',
  'framework.customer.title': 'Customer & Market Insights',
  'framework.customer.desc': 'Customer-centric, supporting diverse payment methods, multilingual services and mobile optimization, helping enterprises quickly adapt to market changes.',
  'framework.technology.title': 'Technical Capability & Scalability',
  'framework.technology.desc': 'Provide flexible, scalable technical solutions, supporting cloud deployment, disaster recovery planning and technology upgrades, ensuring efficient and stable business operations.',
  'framework.finance.title': 'Finance & Operational Efficiency',
  'framework.finance.desc': 'Optimize core business functions, reduce cost risks, while providing training support to help enterprises achieve long-term value.',
  'framework.innovation.title': 'Innovation & Ecosystem Cooperation',
  'framework.innovation.desc': 'Tap potential through data analysis, build an open cooperation ecosystem, and jointly promote digital innovation with enterprises.',
  
  // CTA Section
  'cta.title': 'How Can We Help You?',
  'cta.button': 'Submit Requirements',
  
  // Footer
  'footer.partner': 'Strategic Partner: ',
  'footer.flanexus': 'Flanexus',
  'footer.powered': 'Powerd by AI',

  // News Page
  'news.title': 'News & Insights',
  'news.subtitle': 'Stay updated with the latest digital transformation trends and industry insights',
  'news.all': 'All',
  'news.industry': 'Industry',
  'news.country': 'Country/Region',
  'news.filter.clear': 'Clear Filters',
  'news.filter.showing': 'Showing',
  'news.filter.articles': 'articles',
  'news.filter.article': 'article',
  'news.filter.in': 'in',
  'news.filter.category': 'category',
  'news.filter.total': 'Total',
  'news.loading': 'Loading articles...',
  'news.error': 'Failed to load articles',
  'news.empty': 'No articles found',
  'news.empty.desc': 'No articles match your current filter criteria.',
  'news.readmore': 'Read More',
  'news.published': 'Published on',
  'news.category.fintech': 'FinTech',
  'news.category.ecommerce': 'E-commerce',
  'news.category.healthcare': 'Healthcare',
  'news.category.education': 'Education',
  'news.category.manufacturing': 'Manufacturing',
  'news.category.retail': 'Retail',
  'news.category.logistics': 'Logistics',
  'news.category.government': 'Government',
  'news.category.singapore': 'Singapore',
  'news.category.malaysia': 'Malaysia',
  'news.category.thailand': 'Thailand',
  'news.category.indonesia': 'Indonesia',
  'news.category.vietnam': 'Vietnam',
  'news.category.philippines': 'Philippines',
  'news.category.china': 'China',
  'news.category.japan': 'Japan',
  'news.category.korea': 'South Korea'
};
